import { useDispatch, useSelector } from "react-redux";
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { selectColorScheme, changeColorScheme } from "../slices/colorScheme/colorSchemeSlice.js";

const EmptyBoxCharacter = () => {
    return <span className="box emptyBox">☐&nbsp;</span>;
}

const ColorSchemeToggle = ({ }) => {
    const dispatch = useDispatch();
    const colorScheme = useSelector(selectColorScheme);
    return <ToggleButtonGroup
        className="genericToggleButtonGroup buttonGroupWrap extrathin"
        exclusive
        value={colorScheme}
        aria-label="Feedback Type"
        name="Feedback Type"
    >
        <ToggleButton className="genericToggleButton" color="primary"
            aria-label="Red/Green" value="red-green"
            onClick={() => { dispatch(changeColorScheme("red-green")); }}>
            <span>
                {colorScheme === "red-green" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
            </span>
            Red/Green
        </ToggleButton>
        <ToggleButton className="genericToggleButton" color="primary"
            aria-label="Orange/Blue" value="orange-blue"
            onClick={() => { dispatch(changeColorScheme("orange-blue")); }}>
            <span>
                {colorScheme === "orange-blue" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
            </span>
            Orange/Blue
        </ToggleButton>
        <ToggleButton className="genericToggleButton" color="primary"
            aria-label="Greyscale" value="greyscale"
            onClick={() => { dispatch(changeColorScheme("greyscale")); }}>
            <span>
                {colorScheme === "greyscale" ? <span className="box">☑&nbsp;</span> : <EmptyBoxCharacter />}
            </span>
            Greyscale
        </ToggleButton>
    </ToggleButtonGroup>
}

export default ColorSchemeToggle;